import { WEEK_DAYS } from '@sportninja/common/constants/weekDays'

/** "25.00" / 25 → "25"; "12.50" → "12.5". Keeps meaningful cents, drops
 * trailing zeros so the rate reads cleanly. */
export const formatRate = (rate: string | number): string => {
  const n = Number(rate)
  if (Number.isNaN(n)) {
    return String(rate)
  }
  return String(Number(n.toFixed(2)))
}

/** Available days as a week-ordered short-label list, e.g. "Tue, Wed, Thu".
 * Matches WEEK_DAYS case-insensitively since candidate payloads use lowercase
 * day names while WEEK_DAYS.value is capitalized. */
export const daysLabel = (days: string[]): string => {
  const findDay = (day: string) =>
    WEEK_DAYS.find((w) => w.value.toLowerCase() === day.toLowerCase())
  return [...days]
    .sort((a, b) => (findDay(a)?.index ?? 0) - (findDay(b)?.index ?? 0))
    .map((d) => findDay(d)?.short ?? d)
    .join(', ')
}
